import { useCallback, useMemo } from 'react';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';
const ClearFilters = () => {
  const handleClearFilter = useCallback(() => {}, []);

  const isClearFiltersDisabled = useMemo(() => !0, []);
  return <ClearFilterButton disabled={isClearFiltersDisabled} onClick={handleClearFilter} />;
};

export default ClearFilters;
